import { Button } from '@chakra-ui/react';
import { AiOutlineSecurityScan } from 'react-icons/ai';
import { GiMeshNetwork, GiTwoCoins } from 'react-icons/gi';
import { HiOutlineChip } from 'react-icons/hi';
import { MdPeopleOutline, MdTouchApp } from 'react-icons/md';
import { NavLink } from 'react-router-dom';

import './Section1.css';

function Section1() {
  const featureCards = [
    {
      header: 'Security',
      icon: AiOutlineSecurityScan,
      text: 'Multiple layers of security for your authentication'
    },
    {
      header: 'Credibility',
      icon: MdPeopleOutline,
      text: 'E-Verifiable Certificates & Documents offer additional Credibility'
    },
    {
      header: 'Distribution',
      icon: GiMeshNetwork,
      text: 'Seamless Distribution of Certificates and Documents'
    },
    {
      header: 'Real Time',
      icon: HiOutlineChip,
      text: 'Verify Certificates Anytime and Anywhere'
    },
    {
      header: 'Ease of Use',
      icon: MdTouchApp,
      text: 'One-stop portal for all certificate generation needs'
    },
    {
      header: 'Cost Savings',
      icon: GiTwoCoins,
      text: 'Environment-friendly E-Certificates reduce cost'
    }
  ];

  return (
    <div className="section1-wrapper">

      <div className="section1-hero">
        <h1 className="hero-title">Smart Certificates For</h1>
        <h2 className="hero-subtitle">Smart Organizations</h2>

        <NavLink to="/verify">
          <Button className="verify-btn" backgroundColor="#007bff" color="white">
            Verify Certificate
          </Button>
        </NavLink>
      </div>

      <div className="section1-cards">
        {featureCards.map((card, i) => (
          <div className="section1-card" key={i}>
            <div className="section1-card-icon-wrapper">
              <card.icon size={30} color="#377DFF" />
            </div>
            <div className="card-header">{card.header}</div>
            <div className="card-text">{card.text}</div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default Section1;
